import React from "react";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import {
  getPropertyRequestStatusBadgeClass,
  getPropertyRequestStatusLabel,
} from "../../../constants/propertyRequests";
import { canPublishPropertyRequests } from "../../../constants/plans";

export const RequestsSection = ({
  currentUser,
  myRequests,
  expandedRequest,
  requestResponses,
  loadResponses,
  updateRequestStatus,
  setExpandedRequest,
  navigate,
}) => (
  <AccordionItem
    value="requests"
    className="bg-background border border-border rounded-lg"
  >
    <AccordionTrigger className="px-4 sm:px-6 py-4 hover:no-underline">
      <div className="flex items-center gap-3">
        <Search className="w-5 h-5 text-primary" />
        <span className="font-bold text-base">
          Mis Búsquedas Publicadas ({myRequests.length})
        </span>
      </div>
    </AccordionTrigger>
    <AccordionContent>
      <div className="px-4 sm:px-6 pb-4 space-y-4 max-h-[500px] overflow-y-auto">
        {myRequests.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-sm text-muted-foreground mb-3">
              No has publicado búsquedas
            </p>
            {canPublishPropertyRequests(currentUser) && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => navigate("/create-request")}
              >
                Publicar Búsqueda
              </Button>
            )}
          </div>
        ) : (
          myRequests.map((req) => (
            <div key={req.id} className="border border-border rounded-lg p-4">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <h4 className="font-medium text-sm">{req.title}</h4>
                  <p className="text-xs text-muted-foreground">
                    {req.description?.slice(0, 100)}
                  </p>
                </div>
                <span
                  className={`text-xs px-2 py-1 rounded-full ${getPropertyRequestStatusBadgeClass(req.status)}`}
                >
                  {getPropertyRequestStatusLabel(req.status)}
                </span>
              </div>
              <div className="flex gap-2 mt-2 flex-wrap">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() =>
                    expandedRequest === req.id
                      ? setExpandedRequest(null)
                      : loadResponses(req.id)
                  }
                >
                  {expandedRequest === req.id
                    ? "Ocultar"
                    : `Respuestas (${req.responses_count || 0})`}
                </Button>
                {["active", "in_process"].includes(req.status) && (
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => updateRequestStatus(req.id, "resolved")}
                  >
                    Marcar Completa
                  </Button>
                )}
              </div>
              {expandedRequest === req.id && (
                <div className="mt-3 space-y-2 border-t pt-3">
                  {requestResponses.length === 0 ? (
                    <p className="text-xs text-muted-foreground">
                      Sin respuestas registradas aun.
                    </p>
                  ) : (
                    requestResponses.map((resp, idx) => (
                      <div
                        key={idx}
                        className="p-2 bg-muted/30 rounded text-sm"
                      >
                        <p className="font-medium text-xs">
                          {resp.responder_name}
                        </p>
                        <p className="text-xs text-muted-foreground break-words">
                          {resp.message}
                        </p>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </AccordionContent>
  </AccordionItem>
);
